import { useEffect, useContext } from 'react';
import FeatureFlagsContext from '../context';

const useFeatureFlags = (flags) => {
  const featureFlagsContext = useContext(FeatureFlagsContext);
  const { requestFeatureFlags, featureFlags, requestedFeatureFlags } = featureFlagsContext;

  useEffect(() => {
    requestFeatureFlags(flags);
  }, []);

  return [featureFlags, requestFeatureFlags, requestedFeatureFlags];
};

export default useFeatureFlags;
